import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types';
import { slugify } from '../../utils/slugify';

interface SearchResultsDropdownProps {
    results: Product[];
    onClose: () => void;
}

const SearchResultsDropdown: React.FC<SearchResultsDropdownProps> = ({ results, onClose }) => {
    if (results.length === 0) {
        return (
            <div className="absolute top-full mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-xl z-20 p-4 text-center">
                <p className="text-gray-600">No se encontraron resultados.</p>
            </div>
        );
    }

    return (
        <div className="absolute top-full mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-xl z-20 max-h-96 overflow-y-auto">
            <ul className="divide-y divide-gray-100">
                {results.map(product => (
                    <li key={product.id}>
                        <Link
                            to={`/${slugify(product.category)}/${product.seo?.slug}`}
                            onClick={onClose}
                            className="flex items-center p-3 hover:bg-gray-100 transition-colors"
                        >
                            <img 
                                src={product.imageUrls[0]} 
                                alt={product.name} 
                                className="w-16 h-16 object-contain rounded-md mr-4 bg-gray-50"
                            />
                            <div className="flex-grow">
                                <p className="font-semibold text-gray-800">{product.name}</p>
                                <p className="text-sm text-gray-500">{product.category}</p>
                            </div>
                            <p className="text-lg font-bold text-blue-600">${product.price.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SearchResultsDropdown;